export default __webpack_public_path__ + "static/media/quinoa_porridge.a78a199b.jpg";